<template>
  <transition name="modal">
    <div class="modal-wrapper">
      <div class="modal-container payment-modal">
        <button type="button" class="close" aria-label="Close"><span aria-hidden="true" @click="$emit('closePayment')">&times;</span></button>
        <div class="row">
          <h1>{{lang['Payment']}} {{ payment.device.name }} {{payment.createdAt | formatDateTime}}</h1>
          <div class="col-xs-6">
            <table class="table table-condensed table-hover payment">
              <tbody>
                <tr>
                  <th>resultCode</th>
                  <td>{{payment.resultCode}}</td>
                </tr>
                <tr>
                  <th>status</th>
                  <td>{{payment.status | statusDict}}</td>
                </tr>
                <tr v-if="payment.reversalReason">
                  <th>reversal reason</th>
                  <td>{{payment.reversalReason}}</td>
                </tr>
                <tr>
                  <th>Micros ID</th>
                  <td>{{payment.microsId}}</td>
                </tr>
                <tr>
                  <th>printerNumber</th>
                  <td>{{payment.printerNumber}}</td>
                </tr>
                <tr>
                  <th>transactionNumber</th>
                  <td>{{payment.transactionNumber}}</td>
                </tr>
                <tr>
                  <th>transactionUUID</th>
                  <td>{{payment.transactionUUID}}</td>
                </tr>
                <tr>
                  <th>TID</th>
                  <td>{{payment.TID}}</td>
                </tr>
                <tr>
                  <th>MID</th>
                  <td>{{payment.MID}}</td>
                </tr>
                <tr>
                  <th>cardName</th>
                  <td>{{payment.cardName}}</td>
                </tr>
                <tr>
                  <th>reader</th>
                  <td>{{payment.reader | readerDict}}</td>
                </tr>
                <tr>
                  <th>cardNumber</th>
                  <td>{{payment.cardNumber}}</td>
                </tr>
                <tr>
                  <th>authCode</th>
                  <td>{{payment.authCode}}</td>
                </tr>
                <tr>
                  <th>authMethod</th>
                  <td>{{payment.authMethod | authMethodDict}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-xs-6">
            <table class="table table-condensed table-hover payment">
              <tbody>
                <tr>
                    <th>ARC</th>
                    <td>{{payment.ARC}}</td>
                  </tr>
                  <tr>
                    <th>total</th>
                    <td>{{payment.total | moneyFormat}} {{payment.transactionCurrency}}</td>
                  </tr>
                  <tr>
                    <th>AID</th>
                    <td>{{payment.AID}}</td>
                  </tr>
                  <tr>
                    <th>cryptogramType</th>
                    <td>{{payment.cryptogramType}}</td>
                  </tr>
                  <tr>
                    <th>ATC</th>
                    <td>{{payment.ATC}}</td>
                  </tr>
                  <tr>
                    <th>terminalCurrency</th>
                    <td>{{payment.terminalCurrency}}</td>
                  </tr>
                  <tr>
                    <th>currencyAmount</th>
                    <td>{{payment.currencyAmount | moneyFormat}} {{payment.terminalCurrency}}</td>
                  </tr>
                  <tr>
                    <th>exchangeRate</th>
                    <td>{{payment.exchangeRate}}</td>
                  </tr>
                  <tr>
                    <th>DCCtext1</th>
                    <td>{{payment.DCCtext1}}</td>
                  </tr>
                  <tr>
                    <th>DCCtext2</th>
                    <td>{{payment.DCCtext2}}</td>
                  </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'payment',
  props: ['lang', 'payment'],
  data () {
    return {
    }
  },
  methods: {
    escapeModal (e) {
      if (e.key === 'Escape') {
        this.$emit('closePayment')
      }
    }
  },
  computed: {
  },
  created () {
    window.addEventListener('keyup', this.escapeModal, false)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.escapeModal, false)
  }
}
</script>
<style lang="sass" scoped>
.payment-modal
  position: fixed
  z-index: 999
  margin-top: -20px !important
  margin-left: -20px !important
</style>



// WEBPACK FOOTER //
// src/components/payments/Payment.vue